var map = {
	"./2.psd": "9ebe",
	"./access.jpg": "ad0c",
	"./access.png": "472a",
	"./banner-programacion.jpg": "f715",
	"./cancel.jpg": "bcd8",
	"./cancel.png": "aea9",
	"./charts.png": "b0e0",
	"./check.png": "f0c8",
	"./clientes/fenix.png": "7d80",
	"./clientes/hipermax.png": "3763",
	"./clientes/kas.png": "1b66",
	"./clientes/refrigeracion_colman.png": "f49f",
	"./comision1.png": "0034",
	"./error1.jpg": "0a7e",
	"./error2.png": "406b",
	"./excel.png": "444c",
	"./facebook.png": "5307",
	"./factura1.png": "59a8",
	"./hostinger.png": "56d6",
	"./iconos-reportes/a_cuentas_corrientes.png": "9356",
	"./iconos-reportes/a_cuentas_corrientes2.png": "f17f",
	"./iconos-reportes/cantidad_ventas.png": "17ca",
	"./iconos-reportes/comprado.png": "2f47",
	"./iconos-reportes/deuda-clientes.png": "1445",
	"./iconos-reportes/devoluciones.png": "b9a7",
	"./iconos-reportes/gastos.png": "0ca8",
	"./iconos-reportes/ingresos-netos.png": "821c",
	"./iconos-reportes/ingresos_brutos.png": "d4eb",
	"./iconos-reportes/ingresos_netos.png": "f9e6",
	"./iconos-reportes/iva_comprado.png": "c880",
	"./iconos-reportes/iva_diferencia.png": "4bb5",
	"./iconos-reportes/iva_vendido.png": "a949",
	"./iconos-reportes/pagado.png": "6bdb",
	"./iconos-reportes/pagado_mostrador.png": "ca68",
	"./iconos-reportes/pagado_mostrador2.png": "ca76",
	"./iconos-reportes/productos.png": "4ba96",
	"./iconos-reportes/rentabilidad.png": "965f",
	"./iconos-reportes/ventas.png": "624a",
	"./imagen1.png": "4197",
	"./instagram.png": "c7f8",
	"./layout.jpg": "3cf0",
	"./layout.png": "b5a9",
	"./logo.jpg": "b640",
	"./logo.png": "cf05",
	"./marker.png": "3b84",
	"./nav-icons-2/abm.png": "05ab",
	"./nav-icons-2/clientes 2.png": "f85c",
	"./nav-icons-2/clientes.png": "03d9",
	"./nav-icons-2/listado.png": "f26f",
	"./nav-icons-2/proveedores.png": "f057e",
	"./nav-icons-2/reportes.png": "c1a1",
	"./nav-icons-2/vender.png": "771b",
	"./nav-icons-2/ventas.png": "296b",
	"./nav-icons/abm.png": "56d0",
	"./nav-icons/caja.jpg": "8144",
	"./nav-icons/caja.png": "89de",
	"./nav-icons/caja2.png": "420c",
	"./nav-icons/cajas.png": "dbed",
	"./nav-icons/clientes.jpg": "8097",
	"./nav-icons/clientes.png": "1f6c",
	"./nav-icons/comprobantes.png": "2594",
	"./nav-icons/consulta_precios.png": "c161",
	"./nav-icons/download.png": "4e5e",
	"./nav-icons/empleados.png": "8163",
	"./nav-icons/expenses.png": "b0ff",
	"./nav-icons/listado.png": "fcf3",
	"./nav-icons/lupa.png": "d6bf",
	"./nav-icons/mercado_libre.png": "cb1a",
	"./nav-icons/papelera.png": "1a60",
	"./nav-icons/pendings.png": "3354",
	"./nav-icons/presupuestos.png": "2bc3",
	"./nav-icons/produccion.png": "4153",
	"./nav-icons/proveedores.png": "9469",
	"./nav-icons/proveedoresq.png": "3f91",
	"./nav-icons/tienda.png": "6766",
	"./nav-icons/vender.jpg": "bd8a",
	"./nav-icons/vender.png": "75db",
	"./nav-icons/vender2.png": "2750",
	"./nav-icons/ventas-checked.png": "39e6",
	"./nav-icons/ventas-to-check.png": "f62e",
	"./nav-icons/ventas.png": "68fe",
	"./nuevos-nav-icons/abm.png": "86ac",
	"./nuevos-nav-icons/agenda.png": "7ef4",
	"./nuevos-nav-icons/cajas.png": "d467",
	"./nuevos-nav-icons/clientes.png": "8d3c",
	"./nuevos-nav-icons/comprobantes.png": "a5b0",
	"./nuevos-nav-icons/devoluciones.png": "d6c4",
	"./nuevos-nav-icons/empleados.png": "4690",
	"./nuevos-nav-icons/gastos.png": "e122",
	"./nuevos-nav-icons/inventario.png": "0bc8",
	"./nuevos-nav-icons/online.png": "0580",
	"./nuevos-nav-icons/papelera.png": "fba7",
	"./nuevos-nav-icons/por_entregar.png": "92ec",
	"./nuevos-nav-icons/presupuesto.png": "9298",
	"./nuevos-nav-icons/produccion.png": "efeb",
	"./nuevos-nav-icons/proveedores.png": "9449",
	"./nuevos-nav-icons/recursos.png": "114f",
	"./nuevos-nav-icons/reportes.png": "1fa0",
	"./nuevos-nav-icons/rutas.png": "9e27",
	"./nuevos-nav-icons/tienda_nube.png": "a8a1",
	"./nuevos-nav-icons/vender.png": "7737",
	"./nuevos-nav-icons/ventas.png": "e200",
	"./pago.avif": "60f6",
	"./pago.png": "093c",
	"./portada nueva version.psd": "0d4c",
	"./premium.jpg": "54eb",
	"./premium.png": "53b1",
	"./premium2.png": "6856",
	"./presupuestos.png": "0cb8",
	"./provider.jpg": "b855",
	"./provider.png": "2504",
	"./provider2.png": "ef05",
	"./sonidos/error.mp3": "d09a",
	"./ssl.png": "77ab",
	"./stock.jpg": "af1b",
	"./stock.png": "fcc9",
	"./stock2.png": "1e2c",
	"./stock4.png": "8153",
	"./stock5.png": "6014",
	"./tienda.png": "0187",
	"./tienda2.png": "fcb9",
	"./tienda3.png": "da63",
	"./userplus.png": "6c51",
	"./venta.jpg": "0f5b",
	"./venta.png": "3e83",
	"./whastapp.png": "d355",
	"./youtube.png": "e63a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";